import { Translation } from '../../ts/interfaces/translation.interface';

const warnings: Translation = {
  title: 'Warning',
  subTitle: 'Watch out!',
  notFound: 'No {entity} could be found',
  confirmLeave: 'Are you sure you want to leave the page? All unsaved changes will be lost.',
};
export default warnings;
